import React  from 'react'
import ScrollToTop from "react-scroll-to-top";
import {Link} from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";
import pipehar from "../images/Weight 10.360.jpg";

import Pipeharnew from "../images/pipe har 9500gm.jpg";

import Pipehar8gm from "../images/W 8.100.jpg";
import Pipehargold from "../images/Pipe Har.jpg";
import Pipeharberhampore from "../images/pipe har 10.670.jpg"
import Pipeharproducts from "../images/Pipe Har 10.100gm.jpg";
import har from "../images/Pipe Har 9.690gm.jpg";




import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import pipehar9gmapprox from "../images/pipe har 9500gm.jpg";



import Header from "../inc/Header";

function Pipehar() {
    return (
        <div>
          
    <Header/>
    <br/>
    <br/>
    <br/>
    <br/>
    <ScrollToTop smooth top="100" color="maroon"/>
    <div className='colorbacklockt'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Pipr Har</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                   
                                        <div className="card">
                                        <Zoom>
                                            <img src={pipehar} className="card-img-top" alt="pipehar"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Pipe Har </h5>
                                                <p className="card-text">Weight: 10.360gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                <div className="col-md-6  mt-3">
                           
                                        <div className="card">
                                        <Zoom>
                                            <img src={Pipeharnew} className="card-img-top" alt="Pipeharnew"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Pipe Har </h5>
                                                <p className="card-text">Weight: 9.500gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                    <Zoom>
                                        <img src={Pipehar8gm} className="card-img-top" alt="Pipe Har"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Pipe Har </h5>
                                            <p className="card-text">Weight: 8.100gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className="card">
                                    <Zoom>
                                        <img src={Pipehargold} className="card-img-top" alt="Pipe Har"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Pipe Har                                       </h5>
                                            <p className="card-text">Weight: 12.300gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                  
                                        <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={pipehar9gmapprox} className="card-img-top" alt="Pipe Har"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Pipe Har </h5>
                                                <p className="card-text">Weight: 9.500gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>


                                            </div>
                                        </div>
                                    
                                </div>
                                <div className="col-md-6  mt-3">
                               
                                        <div className="card">
                                        <Zoom>
                                            <img src={Pipeharberhampore} className="card-img-top" alt="Pipe Har"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Pipe Har </h5>
                                                <p className="card-text">Weight: 10.670gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                  
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                    <Zoom>
                                        <img src={Pipeharproducts} className="card-img-top" alt="Pipe Har"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Pipe Har  </h5>
                                            <p className="card-text">Weight: 10.100gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className="card">
                                    <Zoom>
                                        <img src={har} className="card-img-top" alt="Pipe Har"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Pipe Har </h5>
                                            <p className="card-text">Weight: 9.690gm</p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div> 

            {/* <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                  
                                        <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={Pipe Hardesign} className="card-img-top" alt="Pipe Hardesign"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Pipe Har</h5>
                                                <p className="card-text">Weight: </p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>


                                            </div>
                                        </div>
                                    
                                </div>
                                <div className="col-md-6  mt-3">
                               
                                        <div className="card">
                                        <Zoom>
                                            <img src={Pipe Hard} className="card-img-top" alt="necklace"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Pipe Har</h5>
                                                <p className="card-text">Weight: </p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                  
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                    <Zoom>
                                        <img src={Pipe Harcircle} className="card-img-top" alt="Pipe Harcircle"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Pipe Har </h5>
                                            <p className="card-text">Weight: </p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className="card">
                                    <Zoom>
                                        <img src={Pipe Harcircle2} className="card-img-top" alt="Pipe Harcircle2"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Pipe Har </h5>
                                            <p className="card-text">Weight: </p>
                                            <p className="card-text">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>  */}

       
            <br />

            <br />
        </div>
    )
}

export default Pipehar